import { useEffect, useState } from "react";
import toast from "react-hot-toast";
import Checkbox from "./ds/Checkbox";
import Button from "./ds/Button";
import { mediaService } from "../container";

export default function MediaSelection({
  selectedMedias,
  loading,
  onMediasSelected,
  onConfirm,
}) {
  const [loadingMedias, setLoadingMedias] = useState(false);
  const [medias, setMedias] = useState();

  const loadMedias = async () => {
    setLoadingMedias(true);

    try {
      let allMedias = await mediaService.search({
        state: 'active',
      });

      allMedias = allMedias.sort((a, b) => a.name.localeCompare(b.name));

      setMedias(allMedias);
    } catch (err) {
      toast.error('Ocurrió un error al cargar los medios.');
      console.error(err);
    }

    setLoadingMedias(false);
  };

  // Options
  useEffect(() => {
    loadMedias();
  }, []);

  function addMedia(media) {
    onMediasSelected([...selectedMedias, media.id]);
  }

  function removeMedia(media) {
    onMediasSelected(selectedMedias.filter((mediaId) => mediaId !== media.id));
  }

  return (
    <div className="media-selection">
      <div id="edit-user">
        <ul
          className="media"
          style={{
            height: '300px',
          }}
        >
          {medias && medias.map((media) => (
            <li className="t-body-m" key={media.id}>
              <Checkbox
                checked={selectedMedias.some((mediaId) => mediaId === media.id)}
                onchange={(e) => {
                  if (e.target.checked) {
                    addMedia(media);
                    return;
                  }

                  removeMedia(media);
                }}
              />
              {media.name}
            </li>
          ))}
        </ul>
      </div>

      <div style={{ marginTop: '16px', display: 'flex', justifyContent: 'flex-end' }}>
        <Button
          label="Actualizar"
          loading={loadingMedias || loading}
          onclick={async () => {
            await onConfirm(selectedMedias);
          }}
        />
      </div>
    </div>
  );
}
